import React from "react";
import { BaseComponent } from "../../../../base/BaseComponent";
import "./FrontBanner.less";

export default class FrontBanner extends BaseComponent {
  render() {
    return (
      <div className="bca-card">
        {this.antd.colmd12(
          <div className="text-col text-medium">
            <h1 className="gx-text-center heading-big gx-mb-4">
              {this.lang.Our} {this.lang.Blockchain} {this.lang.Consulting}
            </h1>
            <hr className="heading-bottom-line gx-text-center" />
            <p>{this.lang.AdvisoryPara1}</p>
            <p>{this.lang.AdvisoryPara2}</p>
            <p>{this.lang.AdvisoryPara3}</p>
            <br />
            <br />
          </div>
        )}

        <div className="image-col">
          <img src={"/assets/images/telephone.svg"} />
        </div>
      </div>
    );
  }
}
